import { PartnerType } from 'legacy/lut/classes/models/PartnerType'

export const getPartnerTypeByPartnerAccess = (partnerAccess: Record<string, boolean>) => {
  if (partnerAccess.isCommercial) {
    return PartnerType.Commercial
  }
  if (partnerAccess.isDistributor) {
    return PartnerType.Distributor
  }

  return null
}
